import { Box, CardMedia, Typography } from '@mui/material'
import HeaderTextManageApplicant from './HeaderTextManageApplicant'
import { useNavigate, useParams } from 'react-router-dom'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { getOneJobAds, updateJobAds } from 'services/api/modules/recruitment/job-advertisment'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import useOpenClose from 'services/hooks/useOpenClose'
import { useEffect, useState } from 'react'
import ActivateJobAdsModal from './ActivateJobAdsModal'
import SnackbarRecruitment from 'module/recruitment/reusable/SnackbarRecruitment'
import JobAdsPopper from './JobAdsPopper'
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined'
import adnexioLogo from '../../../../../assets/logos/adnexio-logo.svg'
import TextSnippetIcon from '@mui/icons-material/TextSnippet'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import AdxButton from 'components/custom/AdxButton'

const ADNEXIO_JOBS_URL = process.env.REACT_APP_ADNEXIO_JOBS_URL

const HeaderManageApplicant = () => {
  const navigate = useNavigate()

  // params is from the url
  const params = useParams()
  const id = params.id

  // modal/snackbar
  const activateModal = useOpenClose(false)
  const deactivateModal = useOpenClose(false)
  const successActivateSnackbar = useOpenClose(false)
  const successDeactivateSnackbar = useOpenClose(false)
  const errorSnackbar = useOpenClose(false)
  const shareJobModal = useOpenClose(false)

  //api call
  const queryClient = useQueryClient()
  const {
    isLoading: getOneJobAdsIsLoading,
    error: getOneJobAdsError,
    data: getOneJobAdsData,
    refetch: jobAdsRefetch,
  } = useQuery(
    ['getOneJobAds', id],
    async () => {
      const { data } = await getOneJobAds(id)
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )
  const {
    isLoading: deactivateIsLoading,
    isSuccess: deactivateIsSuccess,
    data: deactivateData,
    mutate: deactivateMutate,
  } = useMutation((id) => updateJobAds(id, 'deactivate'), {
    onSuccess: async (response) => {
      successDeactivateSnackbar.handleOpen()
      jobAdsRefetch()
    },
    onError: async (error) => {
      errorSnackbar.handleOpen()
    },
  })
  const {
    isLoading: activateIsLoading,
    isSuccess: activateIsSuccess,
    data: activateData,
    mutate: activateMutate,
  } = useMutation((data) => updateJobAds(id, 'activate', data), {
    onSuccess: async () => {
      successActivateSnackbar.handleOpen()
      jobAdsRefetch()
    },
    onError: async (error) => {
      errorSnackbar.handleOpen()
    },
  })

  const jobBoardUrl = `${window.location.origin}/job-board/${getOneJobAdsData?.company_name}/${getOneJobAdsData?.tenant_identifier}/${getOneJobAdsData?.id}`

  const adnexioJobsUrl = ADNEXIO_JOBS_URL

  const [changeStatus, setChangeStatus] = useState(null)
  const handleChangeStatus = (data) => {
    setChangeStatus(data)
  }
  useEffect(() => {
    if (deactivateIsSuccess) {
      setChangeStatus(deactivateData?.data?.advertisement_status)
      deactivateModal.handleClose()
    }
  }, [deactivateIsSuccess])

  useEffect(() => {
    if (activateIsSuccess) {
      setChangeStatus(activateData?.data?.advertisement_status)
      activateModal.handleClose()
    }
  }, [activateIsSuccess])

  const DeactivateJobAdsModal = () => (
    <AdxInfoModal
      modalWidth={600}
      muiIcon="error_icon"
      open={deactivateModal.isOpen}
      onClose={deactivateModal.handleClose}
      iconColor="error.main"
      title="Deactivate Job Advertisement?"
      subtitle="Are you sure you want to deactivate the job advertisement? This job advertisement will not be visible to the jobseeker and you will not receive new applications."
      variant={'error'}
      footerButtons
      firstBtnLabel={'Deactivate'}
      firstBtnHandle={() => {
        deactivateMutate(id)
        deactivateModal.handleClose = true
      }}
      isLoading={deactivateIsLoading}
      secondBtnLabel={'Cancel'}
      secondBtnHandle={deactivateModal.handleClose}
    />
  )

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 3,
          bgcolor: 'white.main',
          borderRadius: '4.5px',
          border: '1px solid',
          borderColor: 'gray-line.main',
        }}
      >
        <HeaderTextManageApplicant data={getOneJobAdsData} />
        {/* //job advertisment active */}
        {getOneJobAdsData?.advertisement_status === 1 && (
          <>
            <Box display="flex" alignItems="center" columnGap={3}>
              <AdxButton
                variant={'outlined'}
                size="standard"
                color="error"
                onClick={deactivateModal.handleOpen}
                hoverBackgroundColor="light-error.main"
              >
                Deactivate
              </AdxButton>
              <ShareOutlinedIcon
                sx={{ color: 'alternate.main', cursor: 'pointer' }}
                onClick={shareJobModal.handleOpen}
              />
              <Box>
                <JobAdsPopper
                  type="active jobs"
                  id={id}
                  data={getOneJobAdsData}
                  refetch={jobAdsRefetch}
                />
              </Box>
            </Box>
            <ShareJobPostingModal
              shareJobModal={shareJobModal}
              jobBoardUrl={jobBoardUrl}
              adnexioJobsUrl={adnexioJobsUrl}
            />
          </>
        )}

        {/* //job advertisment inactive */}
        {(getOneJobAdsData?.advertisement_status === 3 ||
          getOneJobAdsData?.advertisement_status === 2) && (
          <Box display="flex" alignItems="center" columnGap={4}>
            <AdxButton variant={'outlined'} size="standard" onClick={activateModal.handleOpen}>
              Activate
            </AdxButton>
            <Box>
              <JobAdsPopper
                type="inactive jobs"
                id={id}
                data={getOneJobAdsData}
                refetch={jobAdsRefetch}
              />
            </Box>
          </Box>
        )}
      </Box>

      {deactivateModal.isOpen && <DeactivateJobAdsModal />}

      {activateModal.isOpen && (
        <ActivateJobAdsModal
          open={activateModal.isOpen}
          onClose={activateModal.handleClose}
          handleClose={activateModal.handleClose}
          mutate={activateMutate}
          isLoading={activateIsLoading}
        />
      )}

      {errorSnackbar.isOpen && (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="error"
          TransitionComponent="slide"
          message="An error has occured. Please try again"
          open={errorSnackbar.isOpen}
          handleClose={errorSnackbar.handleClose}
        />
      )}

      {successActivateSnackbar.isOpen && (
        <SnackbarRecruitment
          status="success"
          autoHideDuration={4000}
          TransitionComponent="slide"
          message="Job ad activated"
          open={successActivateSnackbar.isOpen}
          handleClose={successActivateSnackbar.handleClose}
        />
      )}

      {successDeactivateSnackbar.isOpen && (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="success"
          TransitionComponent="slide"
          message="Job ad deactivated"
          open={successDeactivateSnackbar.isOpen}
          handleClose={successDeactivateSnackbar.handleClose}
        />
      )}
    </Box>
  )
}

export default HeaderManageApplicant

export const ShareJobPostingModal = ({ shareJobModal, jobBoardUrl, adnexioJobsUrl }) => {
  const CopyLinkButton = ({ url }) => {
    const [copied, setCopied] = useState(false)

    const handleCopy = () => {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          setCopied(true)
          console.log('Text copied to clipboard')
          setTimeout(() => {
            setCopied(false)
          }, '5000')
        })
        .catch((error) => {
          console.error('Error copying text: ', error)
        })
    }
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: copied ? 'default-background.main' : 'alternate.main',
          p: 2,
          gap: 1,
          borderRadius: '3.5px',
          cursor: copied ? 'default' : 'pointer',
          height: '45px',
          width: '150px',
          transition: 'background-color 0.3s ease',
        }}
        onClick={copied ? null : handleCopy}
      >
        {copied ? (
          <>
            <CheckCircleIcon sx={{ color: 'positive.main' }} />
            <Typography sx={{ color: 'alternate.main', whiteSpace: 'nowrap' }}>
              Link copied!
            </Typography>
          </>
        ) : (
          <>
            <ContentCopyIcon sx={{ color: 'white.main' }} />
            <Typography sx={{ color: 'white.main' }}>Copy link</Typography>
          </>
        )}
      </Box>
    )
  }

  return (
    <AdxInfoModal
      variant={'standard'}
      open={shareJobModal.isOpen}
      onClose={shareJobModal.handleClose}
      title="Share Your Job Posting"
      subtitle="Expand your talent search by sharing your job posting with potential candidates."
      footerButtons
      firstBtnLabel={'Close'}
      firstBtnHandle={shareJobModal.handleClose}
    >
      <Box sx={{ border: 1, borderColor: 'gray-line.main', borderRadius: '4.5px', width: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            padding: '13.5px 16px',
            borderBottom: 1,
            borderBottomColor: 'gray-line.main',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
            <Box
              sx={{
                backgroundColor: 'default-background.main',
                borderRadius: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '8px',
              }}
            >
              <CardMedia
                component="img"
                src={'/adnexio-logo-text.svg'}
                sx={{ height: '30px', width: '30px' }}
              />
            </Box>
            <Typography variant="subtitle1" sx={{ color: 'dark-text.main' }}>
              adnexio.jobs
            </Typography>
          </Box>
          <CopyLinkButton url={adnexioJobsUrl} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            padding: '13.5px 16px',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
            <Box
              sx={{
                backgroundColor: 'default-background.main',
                borderRadius: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '8px',
              }}
            >
              <TextSnippetIcon sx={{ color: 'alternate.main', width: '30px', height: '30px' }} />
            </Box>
            <Typography variant="subtitle1" sx={{ color: 'dark-text.main' }}>
              Your job board
            </Typography>
          </Box>
          <CopyLinkButton url={jobBoardUrl} />
        </Box>
      </Box>
    </AdxInfoModal>
  )
}
